import { ArticleCardLayoutVariant } from 'components/Globals/ArticleCard/articleCardHelpers';
import CustomLink from 'components/Globals/Base/Link';
import styled from 'styled-components';
import { breakpoint, font } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';

const calcNoOfCardsPerRow = (noOfCards: number, maxPerRow: number): number => {
  if (noOfCards <= maxPerRow) return noOfCards;
  if (maxPerRow >= 4 && noOfCards % 4 === 0) return 4;
  if (maxPerRow >= 3 && noOfCards % 3 === 0) return 3;
  return maxPerRow;
};

function imageAspectRatio(variant: ArticleCardLayoutVariant) {
  switch (variant) {
    case 'hero':
    case 'card-xl':
    case 'card-lg':
    case 'card-sm':
    case 'card-md':
      return '3/2';
    default:
      return '16/9';
  }
}

export const Wrapper = styled.div<{ theme: Theme; $noOfCards: number }>`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;

  @media (${breakpoint.mdMin}) {
    grid-template-columns: ${({ $noOfCards }) => `repeat(${calcNoOfCardsPerRow($noOfCards, 4)}, 1fr)`};
  }

  @media (${breakpoint.lgMin}) {
    gap: 24px;
  }
`;

export const PinnedArticleWrapper = styled(CustomLink)<{
  theme: Theme;
}>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: left;
  padding: 16px;
  cursor: pointer;

  @media (${breakpoint.mmMin}) {
    flex-direction: row;
  }
  
  border-top: 3px solid ${getColor('brandPrimary')};
  background: ${getColor('backgroundSecondary')};
  transition: background-color 0.2s ease-out;
  color: ${getColor('textPrimary')};
  letter-spacing: 0.5px;
  text-decoration: none!important;
  gap: 16px;

  h3 {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
    overflow: hidden;
    text-overflow: ellipsis;
    font-weight: 500;
    line-height: 150%;
    margin-bottom: 0;  
    text-align: left;
  }

  & {
    transition: background-color 0.3s ease, color 0.3s ease, box-shadow 0.3s ease; // fade in animation for box-shadow
    box-shadow: 0px 0px 0px 0px transparent;
  }

  &:hover, &:active, &:focus {
    background-color: ${getColor('shadeBrandPrimary100')};
    color: ${getColor('shadeBrandPrimary900')};
  }
 
  &:active > *:not(.no-active) {
    color: ${getColor('shadeBrandPrimary900')};
  }

  &:active, &:focus {
    box-shadow: 0px 0px 7px 0px ${getColor('textLink')};
    outline: none;
  }
`;

export const PinnedCardImage = styled.div<{
  $variant: ArticleCardLayoutVariant;
}>`
  width: 100%;

  @media (${breakpoint.mmMin}) {
    flex: 0 0 70px;
  }

  @media (${breakpoint.lgMin}) {
    flex: 0 0 120px;
  }
  
  img {
    aspect-ratio: ${({ $variant }) => imageAspectRatio($variant)};
    object-fit: cover;
  }
`;

export const PinnedCardBody = styled.div<{
  theme: Theme;
}>`
  display: flex;
  flex-direction: column;
  text-decoration: none !important;

  .card-date {
    color: ${getColor('textSecondary')};
    font-family: ${font.graphikCond};
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 1.17px;
    line-height: 21px;
    margin-top: 2px;
  }
`;
